/** Thin fetch wrapper for the Ìran API. */
export const API_URL = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') || 'http://localhost:8080';

export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string) {
    super(message);
  }
}

let tokenGetter: () => string | null = () => null;
export function setTokenGetter(fn: () => string | null) {
  tokenGetter = fn;
}

export async function api<T = unknown>(path: string, opts: { method?: string; body?: unknown; token?: string | null } = {}): Promise<T> {
  const token = opts.token === undefined ? tokenGetter() : opts.token;
  const res = await fetch(`${API_URL}${path}`, {
    method: opts.method ?? (opts.body ? 'POST' : 'GET'),
    headers: {
      ...(opts.body !== undefined ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new ApiError(res.status, data.error ?? 'error', data.message ?? `Request failed (${res.status})`);
  return data as T;
}

/** Upload a Blob via the signed URL flow: reserve → PUT → complete. Returns the media asset id. */
export async function uploadMedia(blob: Blob, purpose: string): Promise<string> {
  const contentType = (blob.type || 'audio/webm').split(';')[0]!;
  const { mediaAssetId, upload } = await api<{ mediaAssetId: string; upload: { url: string; method: string; headers: Record<string, string> } }>(
    '/media/upload-url',
    { body: { purpose, contentType, sizeBytes: blob.size } },
  );
  const put = await fetch(upload.url, { method: upload.method, headers: upload.headers, body: blob });
  if (!put.ok) throw new ApiError(put.status, 'upload_failed', 'Upload failed — please try again');
  await api(`/media/${mediaAssetId}/complete`, { method: 'POST', body: {} });
  return mediaAssetId;
}

export async function mediaUrl(mediaAssetId: string): Promise<string> {
  const r = await api<{ download: { url: string } }>(`/media/${mediaAssetId}/url`);
  return r.download.url;
}
